import styled from '@emotion/styled';

const CategoryCard = styled.div(props => ({
  height: '100%',
  width: '100%',
  background: 'var(--white-color)',
  display: 'flex',
  alignItems: 'center',
  outline: '1px solid var(--border-color)',
  position: 'relative',
  padding: '16px 40px 16px 24px',
}))

export {
  CategoryCard,
}